import { render, staticRenderFns } from "./MetricCards.vue?vue&type=template&id=be36ebba&scoped=true"
import script from "./MetricCards.vue?vue&type=script&lang=js"
export * from "./MetricCards.vue?vue&type=script&lang=js"
import style0 from "./MetricCards.vue?vue&type=style&index=0&id=be36ebba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be36ebba",
  null
  
)

export default component.exports